import $http from "../../utils/$http";
import { useRequest } from '../../utils/initInstance'
const { post, get } = $http
export default {
    checkWorkNumber: (params, options) => get('/honda-pc/para/checkWorkNumber', params, options),
    logindo: (params, options) => get(process.env.NODE_ENV === 'development' ? '/honda-pc/logintest.do' : '/honda-pc/login2.do', params, options),
    getCaptcha: () => useRequest('/honda-pc/captcha/getCaptcha', {}, { method:'post' })
}